import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppContext } from '@datapad/data-model';
import { Timeline as MuiTimeline } from '@mui/lab';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { TimelineEventItem } from './components/TimelineEventItem.js';
import { TimelineToolbar } from './components/TimelineToolbar.js';
import { useSortedEvents } from './hooks/useSortedEvents.js';
export function Timeline() {
    const appContext = useAppContext();
    const [sortAscending, setSortAscending] = React.useState(true);
    const [selectedEventId, setSelectedEventId] = React.useState(undefined);
    const visibleEvents = appContext.getVisibleEvents();
    const sortedEvents = useSortedEvents(visibleEvents, sortAscending);
    const handleSelectionChange = React.useCallback((eventId) => {
        setSelectedEventId(eventId);
    }, []);
    const handleSortChange = React.useCallback((ascending) => {
        setSortAscending(ascending);
    }, []);
    return (_jsxs(Box, { sx: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
        }, children: [_jsx(TimelineToolbar, { sortAscending: sortAscending, onSortChange: handleSortChange }), _jsx(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    overflow: 'auto',
                    scrollbarWidth: 'thin',
                    flex: 1,
                }, children: _jsx(Box, { sx: { maxWidth: 1000, width: '100%' }, children: sortedEvents.length === 0 ? (_jsx(Box, { sx: {
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: 200,
                            color: 'text.secondary',
                        }, children: _jsx(Typography, { color: "text.secondary", children: "No events to display" }) })) : (_jsx(MuiTimeline, { sx: { p: '3px' }, position: "alternate", children: sortedEvents.map((event, index) => (_jsx(TimelineEventItem, { event: event, selectedEventId: selectedEventId, onSelectionChange: handleSelectionChange, showConnector: index < sortedEvents.length - 1 }, event.id))) })) }) })] }));
}
//# sourceMappingURL=Timeline.js.map